module Bookhus {
    
    export class Bookingkalender {

        private containerId: string;
        private inputfieldId: string;
        //private hideInputfield: boolean;
        private selectedDate: Date;
        private dateShown: Date;
        private localizedValues: LocalizedValues;
        private daystatusService: ICalendarDaydataService;
        private parameters: IBookingkalenderParameters;
        private lastGoodDate: Date;
        private bookingPopup: Bookingpopup;
        
        constructor(inputfieldId: string, parameters: IBookingkalenderParameters) {
            this.inputfieldId = inputfieldId;
            this.parameters = parameters;
            //this.hideInputfield = hideInputfield;
            if (this.parameters === undefined) {
                this.parameters = this.getDefaultparameters();
            }
            
            this.localizedValues = new LocalizedValues(this.parameters.currentCulture);
            if (this.parameters.showHandleBookingsButton) {
                this.bookingPopup = new Bookingpopup(this.parameters.currentCulture, false, false, this.parameters.hasEventModule);
            } else {
                this.bookingPopup = null;
            }

            this.getSelectedDate();

            this.daystatusService = new CalendarDaydataService(this.parameters.minBookingBorder, this.parameters.mediumBookingBorder, this.parameters.currentUserId, true, this.parameters.separateTime, this.parameters.calendarStatusDisplayMode);

            this.loadDataAndRedraw();
            
            //this.createCalendar();
        }

        private getDefaultparameters():IBookingkalenderParameters {
            var parameters: IBookingkalenderParameters = {
                currentCulture: "da",
                hideInputfield: true,
                houseId: 0,
                currentUserId: 0,
                mediumBookingBorder: 10,
                minBookingBorder: 5,
                reservationRestrictions: true,
                monthbarLabel: null,
                showHandleBookingsButton: false,
                isDayOpen: [true, true, true, true, true, true, true],
                separateTime: 12,
                hasEventModule: false,
                showDaysBeforeTodayAsBooked: false,
                showDaysAfterTodayAsBooked: 0,
                isAdmin: false,
                isExternalUser: false,
                datechanged: null,
                earliestYear: null,
                latestYear: null,
                showLockInfo: false,
                calendarStatusDisplayMode: CalendarStatusDisplayMode.Default
            };

            return parameters;
        }

        private loadDataAndRedraw() {
            var daysInMonth = this.daysInMonth(this.dateShown.getMonth() + 1, this.dateShown.getFullYear());
            var startdate = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), 1).addDays(-7);
            var enddate = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), daysInMonth).addDays(7);


            var xhr = this.daystatusService.loadDataAjax(this.parameters.houseId, startdate, enddate);
            var self = this;
            xhr.always(function (jqxhr, textStatus, error) {
                //$("#status").html(textStatus + " " + error);
                self.createCalendar();
            });
        }

        private getSelectedDate() {
            var inputfield = $("#" + this.inputfieldId);
            if (inputfield === undefined || inputfield === null) {
                throw new Error("Datofeltet findes ikke");
            }

            var date = $.datepicker.parseDate(this.localizedValues.datePattern, inputfield.val());
            if (date < new Date(2000, 1, 1)) {
                date = new Date(Date.now());
            }
            
            this.selectedDate = date;
            //this.dateShown = this.selectedDate;
            this.dateShown = new Date(date.getTime()); // <-- super vigtigt at dateShown og selectedDate får forskellige adresser i hukommelsen..
            this.lastGoodDate = new Date(date.getTime());
        }

        private createCalendar() {
            var inputfield = $("#" + this.inputfieldId);
            this.containerId = this.inputfieldId + "_calendar";

            if (this.parameters.hideInputfield) {
                inputfield.hide();
            }

            //if (!this.dateIsAllowed()) {
            //    return;
            //}

            $("." + this.containerId).remove();

            var calendar = $('<div class="' + this.containerId + '"></div>').insertAfter(inputfield);

            // lav måned og årstal kasse, plus frem og tilbagepile
            this.createMonthYearBar(calendar);

            // lav tabel med alle dagene
            this.createTabelWithDays(calendar);

            if (this.bookingPopup !== null) {
                this.createHandleBookingsButton(); 
            }
        }

        //private dateIsAllowed():boolean {
        //    // tjek
        //    if ((this.dateShown > this.daystatusService.mindate) &&
        //        (this.dateShown < this.daystatusService.houseOpenUntill)) {
        //        return true;
        //    }

        //    // er datoen ikke tilladt, ruller vi tilbage til den sidste gode dato
        //    this.dateShown = new Date(this.lastGoodDate.getTime());
        //    return false;
        //}

        private createTabelWithDays(calendar: JQuery) {
            var self = this;
            var tableString = '<table class="calendertable">';

            var days = this.daysInMonth(this.dateShown.getFullYear(), this.dateShown.getMonth() + 1);

            // uge dage
            tableString += '<tr class="daynames"><td>' + this.localizedValues.uge + '</td>';
            var i: number;
            var dayofweek: number;
            for (i = 1; i <= 7; i++) {
                dayofweek = i;
                if (dayofweek === 7) {
                    dayofweek = 0;
                }
                var name = this.localizedValues.dayNamesMin[dayofweek];

                tableString += `<td>${name}</td>`;
            }

            // der skal altid være 7 kolonner, men hvor mange rækker skal vi lave?
            var coloffset = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), 1).getDay() - 1;
            if (coloffset < 0) {
                coloffset = 6;
            }
            var rows = (days + coloffset) / 7;

            // Hvad dag skal vi starte på? dayCounter = 1 starter den første i måneden
            // dayCounter 0 starter sidste dag i måneden før -1 to dage før osv..
            var dayCounter = 1;
            dayCounter -= coloffset;

            var today = new Date().getDateWithoutTime().addDays(self.parameters.showDaysAfterTodayAsBooked);

            // Løb rækkerne igennem
            for (var r = 0; r < rows; r++) {
                tableString += '<tr class="days">';

                // Find ugenummeret og set det ind
                var currentWeek = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), dayCounter).getWeek();
                tableString += "<td>" + currentWeek + "</td>";

                var selectedMonth = this.dateShown.getMonth();
                var currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                // Løb dagene i denne uge igennem
                for (i = 0; i < 7; i++) {
                    dayofweek = i;
                    if (dayofweek === 7) {
                        dayofweek = 0;
                    }

                    var currentDay = new Date(this.dateShown.getFullYear(), this.dateShown.getMonth(), dayCounter++);
                    if (selectedMonth !== currentDay.getMonth()) {
                        tableString += `<td><div class="day notcurrentmonth"><div></div></div></td>`;
                    } else {
                        var dayStatus = this.getDaystatus(currentDay);
                        var dayHasPrice = this.getDayHasPrice(currentDay);
                        if (!dayHasPrice) {
                            dayStatus = "noprice";
                        }
                        var dayActive = "";
                        var dateToCheck = currentDay;
                        dateToCheck.setHours(0, 0, 0, 0);
                        var disableSysMaxForDay = this.daystatusService.sysMaxDateGælderIkkeForLodtrækninger && dayStatus.indexOf('drawperiod') > -1;
                        if ((this.parameters.reservationRestrictions && (!dayHasPrice || currentDay < this.daystatusService.mindate || (currentDay > this.daystatusService.houseOpenUntill && !disableSysMaxForDay)) || dateToCheck < currentDate || dayStatus.indexOf('restrictedPeriod') > -1) ||
                            this.parameters.isDayOpen[dayofweek] === false) {
                            dayActive = "day-not-active";                            
                        }
                        dayStatus = dayStatus.replace('restrictedPeriod', '');

                        var containerStatus = "";
                        if (currentDay.getTime() === this.selectedDate.getTime()) {
                            containerStatus += " selected";
                        }

                        if (!self.parameters.isAdmin && self.parameters.showDaysBeforeTodayAsBooked && currentDay.getDateWithoutTime().getTime() < today.getTime()) {
                            dayStatus = "reservation";
                        }

                        tableString += `<td data-date="${currentDay.toString("dd-MM-yyyy") }" class="${dayActive}"><div class="day ${containerStatus}"><div class="${dayStatus}"><span>${currentDay.getDate()}</span></div></div></td>`;
                    }
                }

                tableString += "</tr>";
            }
            tableString += "</table>";

            calendar.append(tableString);

            this.hookupCalendarClickevents(calendar);
        }

        private hookupCalendarClickevents(calendar: JQuery) {
            // sæt klik event
            var self = this;
            calendar.children().find(".day:not(.notcurrentmonth)").click(function () {
                var day = parseInt($(this).find("span").text());
                var date = new Date(self.dateShown.getFullYear(), self.dateShown.getMonth(), day);
                self.selectedDate = date;

                $("." + self.containerId + " .selected").removeClass("selected");
                $(this).addClass("selected");

                $("#" + self.inputfieldId).val(self.selectedDate.formatDate(self.localizedValues.datePattern));
                $("#" + self.inputfieldId).trigger("change");
                if (self.bookingPopup !== null) {
                    self.updateHandleBookingsButton();
                }
            });

            if (!this.parameters.isAdmin) {
                return;
            }

            const TOOLTIP_DELAY: number = 500;
            const TOOLTIP_TIMEOUT: string = 'tooltipTimeout';

            calendar.find('.days td[data-date]:not(".day-not-active")').on('mouseenter', (e) => {
                var $target = $(e.currentTarget);
                clearTimeout($target.data(TOOLTIP_TIMEOUT));
                $target.data(TOOLTIP_TIMEOUT, setTimeout(() => {
                    $target.off('mouseenter');

                    var dateString = $target.attr("data-date").split("-");
                    var bookingDate = new Date(+dateString[2], +dateString[1] - 1, +dateString[0]);
                    this.daystatusService.getTitleForDay(bookingDate).then((status) => {
                        if (!status) {
                            return;
                        }
                        displayTooltip($target, status);
                    });
                }, TOOLTIP_DELAY));
            });

            calendar.find('.days td[data-date]:not(".day-not-active")').on('mouseleave', (e) => {
                var $target = $(e.currentTarget);
                clearTimeout($target.data(TOOLTIP_TIMEOUT));
            });

            function displayTooltip($target: JQuery, title: string) {
                $target.tooltip({
                    title: title,
                    trigger: 'hover',
                    delay: { show: TOOLTIP_DELAY, hide: 0 }
                } as any);

                $target.on('click', function () {
                    $(this).tooltip('hide');
                });
                $target.tooltip('show');
            }
        }

        private createMonthYearBar(calender: JQuery) {
            var forrigeMåned = '<span class="forrigemåned fa fa-chevron-left mr-auto"></span>';
            var næsteMåned = '<span class="næstemåned fa fa-chevron-right ml-auto"></span>';

            //var månedNavn = this.localizedValues.monthNames[this.dateShown.getMonth()];
            var monthbarLabel = this.parameters.monthbarLabel === null ? "" : `<span class="monthbarLabel px-0 pb-2">${this.parameters.monthbarLabel} </span>`;
            var år = this.dateShown.getFullYear();

            var bar = `
                <div class="calendarmonthbar">
                    ${monthbarLabel}
                    <div class="d-flex justify-content-between align-items-center">
                        ${forrigeMåned}
                        ${this.createMonthDropdown()} <div class="mx-1"></div> ${this.createYearDropdown(this.parameters.earliestYear, this.parameters.latestYear)}
                        ${næsteMåned}
                    </div>
                </div>
            `;
            calender.append(bar);
            var self = this;
            $("." + this.containerId + " .forrigemåned").click(function () {
                self.moveMonth(-1);
            });
            $("." + this.containerId + " .næstemåned").click(function () {
                self.moveMonth(1);
            });
            $("." + this.containerId + " .monthDropdown").change(function () {
                self.moveToMonth($(this).val());
            });
            $("." + this.containerId + " .yearDropdown").change(function () {
                self.moveToYear($(this).val());
            });
        }

        private createMonthDropdown(): string {
            var monthDrop = "";
            this.localizedValues.monthNames.forEach((month, index) => {
                var selected = index === this.dateShown.getMonth() ? ' selected="selected"' : "";
                monthDrop += `<option value="${index}"${selected}>${month}</option>`;
            });
            return `<select class="monthDropdown">${monthDrop}</select>`;
        }

        private createYearDropdown(earliestYear?: number, latestYear?: number): string {
            console.log("TTT", earliestYear, latestYear)
            var yearDrop = "";
            var currentYear = this.dateShown.getFullYear();
            var yearsBack = earliestYear ? earliestYear - currentYear : -5;
            var yearsForward = latestYear ? latestYear - currentYear : 5;

            for (var i = yearsBack; i <= yearsForward; i++) {
                var year = currentYear + i;
                var selected = year === currentYear ? ' selected="selected"' : "";
                yearDrop += `<option value="${year}"${selected}>${year}</option>`;
            }

            return `<select class="yearDropdown">${yearDrop}</select>`;
        }


        private createHandleBookingsButton(): void {
            if ($("#handleBookingsButton").length <= 0) {
                $(".Arrivaldate_calendar").after(`
                    <div class="text-center mt-2">
                        <button type="button" class="btn btn-primary btn-sm " id="handleBookingsButton">Håndter bookinger for <span id="handleBookingsText"></span></button>
                    </div>
                `);
                var self = this;
                $("#handleBookingsButton").on("click", function() {
                    var dateString = $(this).find("#handleBookingsText").html().split("-");
                    var bookingDate = new Date(+dateString[2], +dateString[1] - 1, +dateString[0]);
                    self.bookingPopup.showPopup(self.parameters.houseId, bookingDate, true);
                });
            }
            this.updateHandleBookingsButton();
        }

        private updateHandleBookingsButton(): void {
            $("#handleBookingsText").html(this.selectedDate.toString("dd-MM-yyyy"));
        }

        // -1 = en måned tilbage, +1 = en måned frem, 0 = brug måned som står i #currentMonth
        private moveMonth(direction) {
            this.lastGoodDate = new Date(this.dateShown.getTime());

            this.dateShown.setDate(1);
            this.dateShown.setMonth(this.dateShown.getMonth() + direction);
            this.loadDataAndRedraw();
        }

        private moveToMonth(target) {
            this.lastGoodDate = new Date(this.dateShown.getTime());

            this.dateShown.setDate(1);
            this.dateShown.setMonth(target);
            this.loadDataAndRedraw();
        }

        private moveToYear(target: number): void {
            this.dateShown.setDate(1);
            this.dateShown.setFullYear(target);
            this.loadDataAndRedraw();
        }

        private daysInMonth(year: number, month: number): number {
            return new Date(year, month, 0).getDate();
        }

        private getDaystatus(date: Date): string {
            if (this.daystatusService === undefined) {
                return "empty";
            }
            return this.daystatusService.getStatusForDay(date);
        }
        private getDayHasPrice(date: Date): boolean {
            if (this.daystatusService === undefined) {
                return true;
            }
            return this.daystatusService.dayHasPrice(date);
        }

        setHouseIdAndRedraw(houseId): void {
            this.parameters.houseId = houseId;
            this.loadDataAndRedraw();
        }
    }
}
